import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import "../../../_metronic/_assets/sass/pages/login/login-1.scss";
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import { toAbsoluteUrl } from "../../../_metronic";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
export default function AuthPage() {
  const { companyProfileTheme, reload } = useGlobalData();

  useEffect(() => {
    return () => {};
  }, [reload]);

  return (
    <>
      <div className="kt-grid kt-grid--ver kt-grid--root">
        <div
          id="kt_login"
          className="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1"
        >
          <div
            className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile"
            style={{
              //backgroundImage: "linear-gradient(0deg, rgb(13, 170, 222) 0px, rgb(7, 134, 188) 59%, rgb(2, 98, 154) 100%)",
              backgroundAttachment: "fixed",
              backgroundImage: `${
                companyProfileTheme.ID > 0
                  ? "url(" + companyProfileTheme.imagePath + ")"
                  : `url(${toAbsoluteUrl("/media/bg/bg-aqua.jpg")})`
              }`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            <div
              className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper"
              style={{
                //backgroundImage: "linear-gradient(rgb(2, 98, 154) 0px, rgb(7, 134, 188) 59%, rgb(13, 170, 222) 100%)",
                backgroundAttachment: "fixed",
                backgroundImage: `${
                  companyProfileTheme.ID > 0
                    ? "url(" + companyProfileTheme.imagePath + ")"
                    : `url(${toAbsoluteUrl("/media/bg/bg-aqua.jpg")})`
                }`,
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
            >
              <Switch>
                <Route path="/auth/login" component={Login} />
                <Route path="/auth/registration" component={Registration} />
                <Route
                  path="/auth/forgot-password"
                  component={ForgotPassword}
                />
                <Redirect from="/auth" exact={true} to="/auth/login" />
                <Redirect to="/auth/login" />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
